jQuery( function ( $ ) {

	$( '.remove-performance' ).click( function ( e ) {
		e.preventDefault();
		$( 'input[name="removePerformanceId"]' ).val( $( this ).data( 'value' ) );
		$( this ).closest( 'form' ).submit();
	} );

} );
